// Admin views: use the year selected in the sidebar switcher.
// Dancer-facing views should keep importing static IABF from iabf-collections
// (always the dancer/registration year).

export default {
  computed: {
    /** Year-scoped collection map for the admin festival year. */
    IABF () {
      return this.$store.getters.adminIabf
    },
    adminFestivalYear () {
      return this.$store.getters.adminFestivalYear
    }
  }
}
